// AssignmentPayload contract owner: speak-server/src/@speak-experiments/utils/validations.ts
import { addBreadcrumb } from "@sentry/react";
import { apiClient } from "@/lib/api/client";

export type AssignmentSource = "client" | "wp";
export type BillingRail = "stripe" | "paddle" | "revenuecat" | "direct-deposit" | "none";
export type RevenueTier = "enterprise" | "high" | "mid" | "starter" | "none";

export interface AssignmentCohortSnapshot {
  planId: string | null;
  isTrial: boolean | null;
  isCompanyDomain: boolean | null;
  isPaidSubscriber: boolean | null;
  uploadVolume: number | null;
  magicPromptQueries: number | null;
  billingRail: BillingRail | null;
  revenueTier: RevenueTier | null;
}

export interface AssignmentPayload {
  experimentKey: string;
  variantId: string;
  variantName: string;
  inExperiment: boolean;
  hashAttribute: string | null;
  hashValue: string | null;
  gbClientId: string | null;
  userId: string | null;
  pageLocation: string | null;
  pageReferrer: string | null;
  originalLandingPage: string | null;
  originalReferrer: string | null;
  sessionId: string | null;
  source: AssignmentSource;
  cohortSnapshot: AssignmentCohortSnapshot;
}

export async function postAssignment(payload: AssignmentPayload): Promise<void> {
  try {
    // apiClient's base URL already includes the `/v1` prefix, so the path here
    // must be bare — otherwise it resolves to `…/v1/v1/experiments/assignment` (404).
    await apiClient.post<void>("/experiments/assignment", payload);
  } catch (err) {
    addBreadcrumb({
      category: "experiments",
      level: "warning",
      message: "assignment_post_failed",
      data: {
        experimentKey: payload.experimentKey,
        variantId: payload.variantId,
        error: err instanceof Error ? err.message : String(err),
      },
    });
  }
}
